import React from "react";

const F = { fontFamily: "'Fredoka', sans-serif" };

// Reads the ?challenge=N a beat-my-score share link carries (sent from the
// iOS app's "Challenge a Friend" or a copied web link). Null when absent or
// nonsense, so pages can render nothing.
export const readChallengeTarget = () => {
  try {
    const raw = new URLSearchParams(window.location.search).get("challenge");
    const value = Number.parseInt(raw ?? "", 10);
    return Number.isFinite(value) && value > 0 ? Math.min(value, 999999) : null;
  } catch {
    return null;
  }
};

// The floating challenge chip: "Beat 42!" while playing, flipping to a
// verdict when the run ends. Fixed to the viewport corner so every game page
// can drop it in without caring about its own layout; pointer-events pass
// straight through to the game underneath.
const ChallengeBanner = ({ target, score = 0, ended = false }) => {
  if (!target) return null;
  const beaten = ended && score > target;
  const text = !ended
    ? `Beat ${target}!`
    : beaten
      ? `You beat ${target}!`
      : `${target} to beat — try again!`;

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[950] challenge-banner-in"
      style={F}
      role="status"
      aria-live="polite"
    >
      <div
        key={ended ? "verdict" : "goal"}
        className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-[16px] font-bold text-white ${
          beaten ? "challenge-banner-won" : ""
        }`}
        style={{
          background: beaten
            ? "linear-gradient(135deg, #FFC729, #F4A016)"
            : "linear-gradient(135deg, #408FFF, #0061E0)",
          border: "2px solid rgba(255,255,255,0.88)",
          boxShadow: "0 6px 18px rgba(11,26,51,0.32)",
        }}
      >
        <span aria-hidden>{beaten ? "🏆" : "🎯"}</span>
        <span>{text}</span>
      </div>
      <style>{`
        @keyframes challengeBannerIn {
          0% { transform: translateY(16px) scale(0.7); opacity: 0; }
          60% { transform: translateY(-3px) scale(1.06); opacity: 1; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        .challenge-banner-in { animation: challengeBannerIn 480ms cubic-bezier(0.2, 0.9, 0.3, 1.2) both; }
        @keyframes challengeBannerWon {
          0%, 100% { transform: scale(1) rotate(0); }
          25% { transform: scale(1.08) rotate(-2deg); }
          75% { transform: scale(1.08) rotate(2deg); }
        }
        .challenge-banner-won { animation: challengeBannerWon 900ms ease-in-out 2; }
        @media (prefers-reduced-motion: reduce) {
          .challenge-banner-in, .challenge-banner-won { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default ChallengeBanner;
